/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description loadMoreCountReducer
 */

import { combineActions, handleActions } from 'redux-actions'
import {
  GET_LISTABLES_SUCCESS,
  HIDE,
  INCREMENT_LOAD_MORE_COUNT,
  RESET_LISTABLES,
  RESET_SAVED_SEARCHES_VIEW,
} from '../constants/index'

const loadMoreCountReducer = handleActions(
  {
    [INCREMENT_LOAD_MORE_COUNT]: (state) => (state || 0) + 1,
    [combineActions(HIDE, RESET_LISTABLES, RESET_SAVED_SEARCHES_VIEW)]: () => 0,
    [GET_LISTABLES_SUCCESS]: (state, action) => {
      const { payload } = action
      if (payload) {
        const { offset } = payload
        if (!offset) {
          return 0
        }
      }
      return state
    },
  },
  0
)

export default loadMoreCountReducer
